import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';

import { MSpot } from '../../domain/models/mspot.models';

import { ApiMSpot, MspotParams } from './api-mspot.models';

import { fixLangCode } from '@core/application/use-cases/languages/fix-lang-code.use-case';
import { CommonWindow } from '@core/domain/models/common-window.model';
import { MSPOT_EXTENSION } from '@features/mspot/domain/constants/mspot.const';
import { isDefined } from '@frontend/common/utils';

@Injectable()
export class ApiMspotService {
    constructor(
        private readonly http: HttpClient,
        @Inject(WINDOW) private readonly window: CommonWindow,
    ) {}

    // TODO ECOMDUTI-20988 [SSR][Fase 2] - Reemplazar dependencia con objecto Itx por alternativa compatible con server y client
    public getMspot(
        countryCode: string,
        languageCode: string,
        catalogId: string,
        mspotName: string,
        userFlags: string
    ): Observable<MSpot> {
        const params: MspotParams = {
            spot: `${MSPOT_EXTENSION}${mspotName}`,
            countryCode,
            lang: fixLangCode(languageCode, countryCode),
            catalogId,
            device: 'webApp',
            userFlags,
        };

        let url: string;

        try {
            url = this.requestCmsSpots(params);
        } catch (error) {
            return throwError(() => error);
        }

        return this.http.get<ApiMSpot>(url)
            .pipe(
                map((res) => {
                    return Array.isArray(res.spots) && res.spots.slice(-1).pop();
                }),
            );
    }

    // TODO ECOMDUTI-20988 [SSR][Fase 2] - Reemplazar dependencia con objecto Itx por alternativa compatible con server y client
    private requestCmsSpots(params?: MspotParams): string {
        if (!isDefined(this.window.inditex?.iXPublicVarsMap?.cmsApi)) {
            throw new Error('[mspot.ApiMspotService] - Configuration not found');
        }
        let paramsString = '';
        for (const param of Object.keys(params)) {
            paramsString = `${paramsString}${param}=${params[param]}&`;
        }
        return `${this.window.inditex.iXPublicVarsMap.cmsApi}/marketing/spots?${paramsString}`;
    }
}
